import { Map } from 'immutable';
import actions from '../../constants/auth';

const defaultState = () => new Map({
  remember: true,
  loginItem: new Map(),
  token: sessionStorage.getItem('token') || localStorage.getItem('token') || undefined,
  registrationItem: new Map(),
  registrationAccept: false,
  isLoading: false,
  hasError: false,
  user: undefined,
  emailSendSuccess: false,
  emailSendFail: false,
  passwordChangeSuccess: false,
  passwordChangeFail: false
})

export default (state = defaultState(), action) => {
  switch (action.type) {
    case actions.AUTH_CHANGE_REMEMBER:
      return state.set('remember', action.data);
    case actions.LOGIN_CHANGE_ITEM:
      return state.set('loginItem', action.data);
    case actions.LOGIN_CHANGE_VALUE:
      return state.setIn(['loginItem', action.key], action.data);
    case actions.SIGN_IN:
      return state.set('token', action.data).setIn(['loginItem', 'password'], '');
    case actions.SIGN_OUT:
      return state.set('token', undefined);
    case actions.REGISTRATION_CHANGE_ITEM:
      return state.set('registrationItem', action.data);
    case actions.REGISTRATION_CHANGE_VALUE:
      return state.setIn(['registrationItem', action.key], action.data);
    case actions.REGISTRATION_ACCEPT:
      return state.set('registrationAccept', action.data);
    case actions.AUTH_IS_LOADING:
      return state.set('isLoading', action.data);
    case actions.AUTH_HAS_ERROR:
      return state.set('hasError', action.data);
    case actions.LOAD_USER:
      return state.set('user', action.data);
    case actions.EMAIL_SEND_SUCCESS:
      return state.set('emailSendSuccess', true)
    case actions.EMAIL_SEND_FAIL:
      return state.set('emailSendFail', action.data)
    case actions.PASSWORD_CHANGE_SUCCESS:
      return state.set('passwordChangeSuccess', action.data)
    case actions.PASSWORD_CHANGE_FAIL:
      return state.set('passwordChangeFail', action.data)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/auth/index.js